<template>
  <div>
    <Nav></Nav>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Categorías</h2>
        </b-col>
      </b-row>
      
      <b-row class="mb-3">
        <b-col md="6">
          <b-form-group label="Seleccionar Menú:">
            <b-form-select v-model="selectedMenuId" :options="menuOptions" @change="getCategories"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6" class="d-flex align-items-end">
          <b-button 
            size="sm" 
            variant="success" 
            @click="createCategory"
            :disabled="!selectedMenuId">
            Crear Categoría
          </b-button>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-alert :show="!selectedMenuId" variant="info">
        Selecciona un menú para ver sus categorías
      </b-alert>
      
      <b-row v-if="selectedMenuId">
        <b-col>
          <b-table 
            small 
            responsive 
            striped 
            hover 
            :items="categories" 
            :fields="tableFields"
            :filter="search"
            :busy="isLoading">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(is_active)="data">
              <b-badge variant="success" v-if="data.item.is_active">Activo</b-badge>
              <b-badge variant="danger" v-else>Inactivo</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button-group>
                <b-button size="sm" variant="warning" @click="editCategory(data.item)">
                  Editar
                </b-button>
                <b-button size="sm" variant="info" @click="redirectToItems(data.item.id)">
                  Ver Items
                </b-button>
                <b-button size="sm" variant="danger" @click="confirmDeleteCategory(data.item.id)">
                  Eliminar
                </b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>

    <!-- Create/Edit Category Modal -->
    <b-modal 
      id="modal-category" 
      :title="isEditing ? 'Editar Categoría' : 'Crear Categoría'" 
      @ok.prevent="submitCategory"
      @hidden="resetForm">
      <form ref="categoryForm" @submit.stop.prevent="submitCategory">
        <b-form-group
          label="Nombre:"
          label-for="name-input"
          :state="nameValidation"
          :invalid-feedback="'El nombre es requerido'">
          <b-form-input
            id="name-input"
            v-model="currentCategory.name"
            :state="nameValidation"
            required
          ></b-form-input>
        </b-form-group>
        
        <b-form-group label="Descripción:">
          <b-form-textarea
            v-model="currentCategory.description"
            placeholder="Descripción de la categoría"
            rows="3"
          ></b-form-textarea>
        </b-form-group>
        
        <b-form-group label="Posición:">
          <b-form-input
            v-model.number="currentCategory.sorting_position"
            type="number"
            min="0"
          ></b-form-input>
          <small class="form-text text-muted">Determina el orden de visualización</small>
        </b-form-group>
        
        <b-form-group>
          <b-form-checkbox v-model="currentCategory.is_active">
            Categoría Activa
          </b-form-checkbox>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../Nav.vue";

export default {
  name: "PlatformCategories",
  components: { Nav },

  data() {
    return {
      categories: [],
      menus: [],
      selectedMenuId: "",
      isLoading: false,
      isEditing: false,
      search: "",
      currentCategory: {
        id: "",
        menu_id: "",
        name: "",
        description: "",
        sorting_position: 0,
        is_active: true
      },
      tableFields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        { key: "sorting_position", label: "Posición", sortable: true },
        { key: "is_active", label: "Estado", sortable: true },
        { key: "buttons", label: "Acciones" }
      ]
    };
  },
  computed: {
    menuOptions() {
      const options = this.menus.map(menu => ({
        value: menu.id,
        text: menu.name
      }));
      
      return [
        { value: "", text: "Selecciona un menú", disabled: true },
        ...options
      ];
    },
    nameValidation() {
      return this.currentCategory.name ? true : false;
    }
  },
  mounted() {
    this.getMenus();
    
    // Check if menu_id is in route params
    if (this.$route.params.menu_id) {
      this.selectedMenuId = this.$route.params.menu_id;
      this.getCategories();
    }
  },
  methods: {
    getMenus() {
      axios
        .get("/platform/menus")
        .then(response => {
          this.menus = response.data;
        })
        .catch(err => {
          this.makeToast("Error", err.response?.data?.message || "Error al obtener menús", "danger");
        });
    },
    getCategories() {
      if (!this.selectedMenuId) return;
      
      this.isLoading = true;
      axios
        .get(`/platform/menu/${this.selectedMenuId}/categories`)
        .then(response => {
          this.categories = response.data;
        })
        .catch(err => {
          this.makeToast("Error", err.response?.data?.message || "Error al obtener categorías", "danger");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    createCategory() {
      this.isEditing = false;
      this.currentCategory = {
        id: "",
        menu_id: this.selectedMenuId,
        name: "",
        description: "",
        sorting_position: 0,
        is_active: true
      };
      this.$bvModal.show("modal-category");
    },
    editCategory(category) {
      this.isEditing = true;
      this.currentCategory = { ...category };
      this.$bvModal.show("modal-category");
    },
    submitCategory() {
      if (!this.currentCategory.name) {
        return; // Validation failed
      }

      const method = this.isEditing ? "PUT" : "POST";
      const url = this.isEditing 
        ? `/platform/category/${this.currentCategory.id}` 
        : `/platform/menu/${this.selectedMenuId}/category`;
      
      axios({
        method,
        url,
        data: this.currentCategory
      })
        .then(() => {
          this.makeToast(
            "Éxito", 
            `Categoría ${this.isEditing ? 'actualizada' : 'creada'} exitosamente`, 
            "success"
          );
          this.getCategories();
          this.$bvModal.hide("modal-category");
        })
        .catch(err => {
          this.makeToast(
            "Error", 
            err.response?.data?.message || `Error al ${this.isEditing ? 'actualizar' : 'crear'} la categoría`, 
            "danger"
          );
        });
    },
    confirmDeleteCategory(id) {
      this.$bvModal.msgBoxConfirm("¿Estás seguro que deseas eliminar esta categoría? Esta acción no se puede deshacer.", {
        title: "Confirmar eliminación",
        okVariant: "danger",
        okTitle: "Eliminar",
        cancelTitle: "Cancelar",
        centered: true
      })
      .then(result => {
        if (result) {
          this.deleteCategory(id);
        }
      });
    },
    deleteCategory(id) {
      axios
        .delete(`/platform/category/${id}`)
        .then(() => {
          this.makeToast("Éxito", "Categoría eliminada exitosamente", "success");
          this.getCategories();
        })
        .catch(err => {
          this.makeToast(
            "Error", 
            err.response?.data?.message || "Error al eliminar la categoría", 
            "danger"
          );
        });
    },
    redirectToItems(categoryId) {
      this.$router.push({ 
        name: 'platform-items', 
        params: { 
          menu_id: this.selectedMenuId,
          category_id: categoryId
        } 
      });
    },
    resetForm() {
      this.currentCategory = {
        id: "",
        menu_id: this.selectedMenuId,
        name: "",
        description: "",
        sorting_position: 0,
        is_active: true
      };
      this.isEditing = false;
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    }
  }
};
</script>
